/**
 * Ícono (?) reutilizable con tooltip explicativo.
 * Uso: <HelpTooltip title="..." description="..." example="..." />
 */
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { HelpCircle, Info } from 'lucide-react';

export default function HelpTooltip({ title, description, example, side = 'top', className = '' }) {
  if (!title || !description) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full text-neutral-400 transition-colors hover:text-[#F05D5E] focus:outline-none focus:ring-2 focus:ring-[#F05D5E]/30 ${className}`}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          data-testid="help-tooltip-trigger"
          aria-label={`Ayuda sobre ${title}`}
        >
          <HelpCircle className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-72 border-neutral-200 p-4 text-sm shadow-xl"
        side={side}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-1 flex items-center gap-2">
          <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#fce8e5]">
            <Info className="h-3.5 w-3.5 text-[#F05D5E]" />
          </div>
          <h4 className="font-semibold text-neutral-900">{title}</h4>
        </div>
        <p className="text-neutral-600">{description}</p>
        {example ? (
          <div className="mt-3 rounded-lg bg-neutral-50 p-2.5">
            <p className="text-[11px] font-medium uppercase tracking-wide text-neutral-500">Ejemplo</p>
            <p className="mt-0.5 text-xs text-neutral-700">{example}</p>
          </div>
        ) : null}
      </PopoverContent>
    </Popover>
  );
}
